import { Progress, Statistic } from "@scuf/common";
import "./MineralCard.css";

export default function MineralCard({
  isLoading = false,
  title = "",
  value = 0,
  unit = "",
}) {
  return (
    <>
      {isLoading ? (
        <Statistic
          className="static-container"
          value={<Progress circular={true} />}
          label={"Cargando datos..."}
        />
      ) : (
        <Statistic
          className="static-container"
          value={value + " " + unit}
          label={title}
        />
      )}
    </>
  );
}
